import { useState } from 'react';
import { RequestsIcon } from '@/components/icons';
import { RequestCard } from '@/components/requests/RequestCard';
import { EmptyState } from '@/components/ui/EmptyState';
import { Notice } from '@/components/ui/Notice';
import { PageHeader } from '@/components/ui/PageHeader';
import { Spinner } from '@/components/ui/Spinner';
import { usePendingRequests, useRequestHistory } from '@/hooks/useAdminData';

/**
 * בקשות שינוי מכל העבודות. הרשימה חיה: כשמנהל אחד מאשר או דוחה,
 * הבקשה נעלמת מהרשימה אצל כל המנהלים מיד.
 */
export function RequestsPage() {
  const [tab, setTab] = useState<'pending' | 'history'>('pending');
  const pending = usePendingRequests();
  const history = useRequestHistory();
  const list = tab === 'pending' ? pending : history;

  return (
    <>
      <PageHeader title="בקשות שינוי" subtitle="הכמות משתנה רק אחרי אישור. כל מנהל רואה מיד מה כבר טופל." />

      <div role="tablist" className="mb-5 inline-flex rounded-control bg-sunken p-1">
        {(['pending', 'history'] as const).map((t) => (
          <button
            key={t}
            type="button"
            role="tab"
            aria-selected={tab === t}
            onClick={() => setTab(t)}
            className={`min-h-10 rounded-[8px] px-4 text-[14px] font-medium ${tab === t ? 'bg-surface text-ink shadow-sm' : 'text-ink-2'}`}
          >
            {t === 'pending' ? `ממתינות${pending.state === 'ready' ? ` (${pending.data.length})` : ''}` : 'היסטוריה'}
          </button>
        ))}
      </div>

      {list.state === 'loading' && (
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      )}
      {list.state === 'error' && <Notice tone="error">{list.message}</Notice>}
      {list.state === 'ready' && list.data.length === 0 && (
        <EmptyState
          icon={<RequestsIcon size={30} />}
          title={tab === 'pending' ? 'אין בקשות ממתינות' : 'אין עדיין היסטוריה'}
          body={tab === 'pending' ? 'כשקבלן או עובד יבקשו שינוי בכמות או ביטול הגעה — הבקשה תופיע כאן.' : 'בקשות שאושרו, נדחו או בוטלו יופיעו כאן.'}
        />
      )}
      {list.state === 'ready' && list.data.length > 0 && (
        <div className="grid gap-3 lg:grid-cols-2">
          {list.data.map((r) => (
            <RequestCard key={r.id} r={r} />
          ))}
        </div>
      )}
    </>
  );
}
